import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CompanyForm362Component } from '../../asic-forms/company';
import { Company } from '@models/companies/company';
import { Document } from '@models/documents/document';
import { EntityChangeData } from '@models/documents/entity-change-data';
import { CompanyChangeData } from '@models/ui-models/company-change-data';
import { ChangeDictionaryHelper } from '@models/ui-models/change-dictionary-helper.model';

export enum Form362Type {
  Appointment = 0,
  Cessation = 1
}

export class CompanyForm362 extends EntityChangeData {
  static override readonly $type = 'CompanyForm362';
  companyACN: string;
  companyName: string;
  actionType: Form362Type;

  constructor(data: Partial<CompanyForm362> = {}) {
    super(data);
    this.companyACN = data.companyACN ?? '';
    this.companyName = data.companyName ?? '';
    this.actionType = Form362Type.Appointment;
  }

  override toDictionary(): { key: string; value: string; }[] {
    const dict = new ChangeDictionaryHelper();

    dict
      .add('Company Name', this.companyName)
      .addAcn('ACN', this.companyACN);

    return dict.dictionary;
  }

  override fillModal(modalRef: NgbModalRef, document: Document, actualCompany = new Company()): NgbModalRef {
    modalRef = this.fillModalWithCompany(modalRef, actualCompany, true);
    (modalRef.componentInstance as CompanyForm362Component).companyChangeData.documentId = document.documentId;
    return modalRef;
  }

  fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit: boolean): NgbModalRef {
    const instance = modalRef.componentInstance as CompanyForm362Component;

    instance.isEdit = isEdit;
    instance.companyChangeData = new CompanyChangeData(company);
    instance.formModel = this;
    instance.address = company.registeredAddress ?? company.principalAddress;

    return modalRef;
  }

  override prepareToRequest(): CompanyForm362 {
    return {
      ...this,
      ...super.prepareToRequest(),
    };
  }
}
